import { WebStorage } from 'proxy-storage'
const sessionStorage = new WebStorage('sessionStorage')

function removeSalesforceData(): void {
  const removeKeys = []

  for (const key in sessionStorage) {
    if (
      key.indexOf('pivotSFOpportunity') > -1 ||
      key.indexOf('pivotSFLeadId') > -1 ||
      key.indexOf('pivotSFAddOn') > -1
    ) {
      removeKeys.push(key)
    }
  }
  removeKeys.forEach(key => {
    sessionStorage.removeItem(key)
  })
}

export { removeSalesforceData }
